import { render, staticRenderFns } from "./ShareBtn.vue?vue&type=template&id=03d62b1a"
import script from "./ShareBtn.vue?vue&type=script&lang=js"
export * from "./ShareBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports